<!-- 服务商列表 -->
<template>
  <div class="serviceList">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/appmarket' }">供需市场</el-breadcrumb-item>
        <el-breadcrumb-item>服务商列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="fastSoo width">
      <div class="appItemList">
        <div class="appItem" v-for="(item,i) in ListData.items" :key="i">
          <div class="appItemImg">
            <img :src="item.cover_logo" alt srcset />
          </div>
          <div class="appItemCon">
            <div class="title">{{item.name}}</div>
            <div class="pp">
              <p>软件服务商</p>
            </div>
            <span class="attestation">{{item.is_renzhen==1?'已验证':'未验证'}}</span>
            <span class="supplier">联系人：{{item.contacts}}</span>
            <span class="browse">公司邮箱：{{item.conemail}}</span>
          </div>
          <div class="appDetails">
            <el-button type="primary" @click="goDetails(item.id)">查看详情</el-button>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="totalPage"
          :page-size="10"
          layout="total,prev, pager, next, jumper"
          :total="total"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '服务商列表',
        bgImg: require('../assets/images/u3244.jpg'),
        content: '为您提供优质服务商，提供优质的服务',
        bl: false,
      },
      ListData: [],
      total: 0,
      totalPage: 1,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getListData()
  },
  mounted() {},
  methods: {
    async getListData() {
      const res = await this.$http.post('/getProviderlist', {
        pages: this.totalPage,
      })
      this.ListData = res.data.data
      this.total = res.data.data.total
    },
    goDetails(i) {
      this.$router.push({
        name: 'serviceDetails',
        params: {
          //params 传递参数
          ids: i,
        },
      })
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.totalPage = val
      this.getListData()
    },
  },
}
</script>

<style lang="less" scoped>
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.fastSoo {
  .appItemList {
    .appItem {
      display: flex;
      background-color: #fff;
      margin-bottom: 10px;
      .appItemImg {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          max-height: 160px;
          padding: 20px 10px 20px 10px;
          box-sizing: border-box;
        }
      }
      .appItemCon {
        flex: 5;
        .title {
          font-weight: 700;
          font-size: 16px;
          margin-top: 15px;
        }
        .pp {
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
            flex: 7;
          }
          span {
            flex: 1;
          }
        }
        .attestation {
          display: block;
          color: #16c31d;
        }
        .supplier {
          display: block;
          margin: 10px 0;
        }
        .browse {
          display: block;
          margin-bottom: 10px;
        }
      }
      .appDetails {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.el-pagination {
  text-align: center;
  padding: 20px 0;
  background-color: #fff;
}
</style>
